/** @jsx jsx */
import React from 'react';
import { MoreButton } from '@design-system';
import { useRouter } from 'hooks/useRouter';
import { jsx } from '@emotion/react';
import { translations } from 'translations';
import { FormIcon } from '@design-system/icons/FormIcon';
import { ListIcon } from '@chakra-ui/react';

const links = [
  {
    label: translations.COMMON.EDIT,
    value: 'edit',
  },
  {
    label: translations.COMMON.DELETE,
    value: 'delete',
  },
];

export const FormCard = ({
  borderColor,
  form,
  showMore = false,
  name,
  onFormMenuClick = (_val: any, _id: any) => {},
}) => {
  const router = useRouter();
  const goToForm = () => {
    router.history.push({
      pathname: `/forms/use`,
      state: {
        ...form,
      },
    });
  };

  return (
    <div className="">
      <div
        className="card flex h-24 w-full cursor-pointer items-center justify-center p-4"
        css={{ '&:hover': { borderColor } }}
        onClick={goToForm}></div>
      <div className="flex">
        <p
          className="m-auto mt-2 w-11/12 cursor-pointer overflow-ellipsis text-center text-paragraph-sm"
          onClick={goToForm}>
          {name}
        </p>
        {showMore && (
          <MoreButton
            className="relative top-2 mr-2 ml-auto w-1/12"
            items={links as any}
            onClick={(value) => onFormMenuClick(value, form)}
          />
        )}
      </div>
    </div>
  );
};
